import { DesignSystemModule } from '../modules/designSystem';
import { StartupSubPageShell } from './StartupSubPageShell';

export default function StartupDesignSystemPage(): JSX.Element {
  return (
    <StartupSubPageShell activeSection="design-system">
      {() => <DesignSystemModule />}
    </StartupSubPageShell>
  );
}
